import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DecisioningStudioPersonalizationExplainerPage = lazy(() =>
  import(
    "@scenes/OfferFit/components/OfferFitUseCaseDetails/components/DecisioningStudioUseCaseInsights/components/DecisioningStudioPersonalizationExplainerPage"
  ).then((module) => ({
    default: module.DecisioningStudioPersonalizationExplainerPage,
  }))
);

export const decisioningStudioPersonalizationExplainerNRO: NavigationRoutingObject = {
  Component: DecisioningStudioPersonalizationExplainerPage,
  // Domain flippers gate visibility in getDeveloperNavigationAllowed; this list is only for
  // the React-vs-Knockout transition, and this page has no Knockout equivalent.
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "offerfit",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t(
      "decisioning-studio-personalization-explainer-nro-heading",
      "BrazeAI Decisioning Studio™ Personalization Explainer"
    ),
  pageNameForTracking: () => "BrazeAI Decisioning Studio™ Personalization Explainer",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "decisioning-studio-personalization-explainer-nro-description",
      "See how a dimension contributed to a BrazeAI Decisioning Studio™ agent's incremental lift"
    ),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    if (!featureOn("offerfit_dashboard") || !featureOn("decisioning_studio_insights")) {
      return false;
    }

    const userHasViewDecisioningStudioAgentsPermission = hasPermission("appGroup", {
      permission: "viewDecisioningStudioAgents",
    });

    return isImpersonating || userHasViewDecisioningStudioAgentsPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/decisioning_studio/agents/:appGroupId",
};
